<template>
  <div class="bg-white overflow-hidden shadow rounded-lg mb-4">
    <div class="px-4 py-5 sm:p-6">
      <div class="flex items-center">
        <div class="flex-shrink-0 rounded-md w-12 h-12 text-center flex justify-center items-center"
             :class="`bg-${type}`">
          <i :class="icon" class="text-white text-xl"></i>
        </div>
        <div class="ml-5 w-0 flex-1">
          <dl>
            <dt class="text-sm leading-5 font-medium text-gray-500 truncate">
              {{smallTitle}}
            </dt>
            <dd class="flex items-center h-8">
              <div class="text-2xl leading-8 font-semibold text-gray-900">
                <i key="loading" v-if="loading" :class="`text-${type}`" class="fas fa-spinner fa-spin"></i>
                <template v-else>
                  <slot name="title">
                    {{title}}
                  </slot>
                </template>
              </div>
              <div v-if="previousTitle !== undefined"
                   class="pr-4 ml-1 flex-shrink-0 flex items-center">
                <div class="ml-2 mr-2 flex-shrink-0 flex">
                  <div
                    class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 md:mt-2 lg:mt-0"
                    :class="{
                      'bg-green-100 text-green-800': percentageDiff > 0,
                      'bg-red-100 text-red-800': percentageDiff < 0,
                      'bg-gray-100 text-gray-800': percentageDiff === 0,
                    }"
                  >
                    <svg v-if="percentageDiff > 0"
                         class="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500"
                         fill="currentColor"
                         viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                            d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                            clip-rule="evenodd"></path>
                    </svg>
                    <svg v-else-if="percentageDiff < 0"
                         class="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-red-500"
                         fill="currentColor"
                         viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                            d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                            clip-rule="evenodd"></path>
                    </svg>
                    <span class="sr-only">
                      <template v-if="percentageDiff === 0">
                          {{$t('The same')}}
                      </template>
                      <template v-else-if="percentageDiff < 0">
                          Decreased by
                      </template>
                          <template v-else-if="percentageDiff > 0">
                          Increased by
                      </template>
                    </span>
                    {{formattedPercentage}}%
                  </div>
                </div>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { FadeTransition } from 'vue2-transitions'

  export default {
    name: 'stats-card',
    components: {
      FadeTransition
    },
    props: {
      type: {
        type: String,
        description: 'Card text type (primary|info|danger|default|warning|success)'
      },
      title: {
        type: [String, Number],
        description: 'Card title'
      },
      smallTitle: {
        type: String,
        description: 'Card small title'
      },
      icon: {
        type: String,
        description: 'Card icon'
      },
      loading: Boolean,
      previousTitle: {
        type: [String, Number]
      }
    },
    computed: {
      percentageDiff () {
        const prevValue = +this.previousTitle || 1
        const currentValue = +this.title
        const difference = currentValue - prevValue
        if (isNaN(difference)) {
          return 0
        }
        return (difference / prevValue) * 100
      },
      formattedPercentage () {
        const percentage = Math.abs(this.percentageDiff)
        if (percentage === 0) {
          return 0
        }
        if (percentage > 1000) {
          return `${(percentage / 1000).toFixed(1)}K`
        }
        return percentage.toFixed()
      }
    }
  }

</script>
<style scoped>
  .card-stats {
    min-height: 120px
  }
</style>
